import{useInitGoogleAnalytics as n}from"@edikk-edikk/hooks";const o=({config:e})=>(n(e?.measurementId),null);export{o as ConnectGoogleAnalytics};
